import { css, ThemedCssFunction } from 'styled-components';
import { screenSizes } from 'constants/styled-theme';

export const media = (Object.keys(screenSizes) as (keyof typeof screenSizes)[]).reduce(
  (acc, label) => {
    acc[label] = (first: any, ...args: []) => css`
      @media (min-width: ${screenSizes[label]}px) {
        ${css(first, ...args)}
      }
    `;
    return acc;
  },
  {} as { [key in keyof typeof screenSizes]: ThemedCssFunction<any> }
);

export const mediaMaxWidth = (Object.keys(screenSizes) as (keyof typeof screenSizes)[]).reduce(
  (acc, label) => {
    acc[label] = (first: any, ...args: []) => css`
      @media (max-width: ${screenSizes[label]}px) {
        ${css(first, ...args)}
      }
    `;
    return acc;
  },
  {} as { [key in keyof typeof screenSizes]: ThemedCssFunction<any> }
);
